import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Bell, BellOff, Share } from 'lucide-react';
import { pushSupported, isIOS, isStandalone, currentSubscription, enablePush, disablePush } from '../lib/push';

export const PushButton = ({ label = 'Avísame de nuevas entradas', className = '', testid = 'push-toggle', dark = false }) => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showIOSHelp, setShowIOSHelp] = useState(false);

  useEffect(() => { currentSubscription().then(s => setOn(!!s)).catch(() => {}); }, []);

  const needsInstall = isIOS() && !isStandalone();
  if (!pushSupported() && !needsInstall) return null;

  const click = async () => {
    if (needsInstall) { setShowIOSHelp(v => !v); return; }
    setBusy(true);
    try {
      if (on) { await disablePush(); setOn(false); toast.success('Avisos desactivados'); }
      else { await enablePush(); setOn(true); toast.success('¡Listo! Te avisaré en este dispositivo'); }
    } catch (e) {
      toast.error(e.message === 'denied' ? 'Has bloqueado las notificaciones. Actívalas en los ajustes del navegador.' : 'No se pudieron activar los avisos');
    } finally { setBusy(false); }
  };

  return (
    <div className={className}>
      <button onClick={click} disabled={busy} data-testid={testid}
        className={`inline-flex items-center gap-2 px-4 py-2 border ${dark ? 'border-stilo-stone/50 text-stilo-bg' : 'border-stilo-ink/30 text-stilo-ink'} text-xs tracking-[0.18em] uppercase hover:opacity-80 transition-opacity disabled:opacity-50`}>
        {on ? <BellOff className="w-4 h-4" strokeWidth={1.5} /> : <Bell className="w-4 h-4" strokeWidth={1.5} />}
        {on ? 'Desactivar avisos' : label}
      </button>
      {showIOSHelp && (
        <p className="mt-3 text-xs max-w-xs leading-relaxed" data-testid={`${testid}-ios-help`}>
          En iPhone: pulsa <Share className="inline w-3.5 h-3.5 -mt-0.5" /> <strong>Compartir</strong> → <strong>Añadir a pantalla de inicio</strong>, abre la app desde el icono y vuelve a pulsar este botón.
        </p>
      )}
    </div>
  );
};
